import { useState } from 'react';
import { t } from 'utilities/TranslationUtils';
import FilterPill from 'pages/Sessions/components/FilterPill';
import FilterPopover from 'pages/Sessions/components/FilterPopover';

interface Props {
  options: ReadonlyArray<{ value: string; label: string }>;
  /** Selected session types; empty = all. */
  selected: ReadonlyArray<string>;
  onChange: (selected: string[]) => void;
}

/** Multi-select session-type filter pill (same look and popover as the result filter in the session-type views). */
export default function SessionKindFilterPill({ options, selected, onChange }: Props) {
  const [open, setOpen] = useState(false);
  if (options.length < 2) return null;
  const labelOf = (value: string) => options.find((o) => o.value === value)?.label ?? value;
  const label = selected.length === 0 || selected.length === options.length
    ? t('playerPerformance.allSessionTypes')
    : selected.length === 1
      ? labelOf(selected[0])
      : t('playerPerformance.sessionTypesSelected', { count: selected.length });
  return (
    <FilterPill label={label} active={selected.length > 0} open={open} onToggle={() => setOpen((v) => !v)} dataTest='pp-session-kind-filter'>
      <FilterPopover
        title={t('playerPerformance.sessionTypeFilter')}
        options={options}
        selected={selected}
        onChange={onChange}
        onClose={() => setOpen(false)}
      />
    </FilterPill>
  );
}
